// noinspection JSUnusedGlobalSymbols

import { teamsSlice } from './teams.slice.ts';

export const { resetTeams } = teamsSlice.actions;
